/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPersonas_creditApplication_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson = { readonly __typename: 'SignedCreditApplicationPerson', readonly firstName: string, readonly lastName: string };

export type GetPersonas_creditApplication_CreditApplication_personaInquiries_PersonaInquiry = { readonly __typename: 'PersonaInquiry', readonly status: _Types.PersonaInquiryStatus, readonly inquiryId: string, readonly person: GetPersonas_creditApplication_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson };

export type GetPersonas_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly personaInquiries: ReadonlyArray<GetPersonas_creditApplication_CreditApplication_personaInquiries_PersonaInquiry> };

export type GetPersonas_Query = { readonly __typename: 'Query', readonly creditApplication: GetPersonas_creditApplication_CreditApplication | null };


export type GetPersonasVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetPersonas = GetPersonas_Query;


export const GetPersonasDocument = gql`
    query GetPersonas($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    personaInquiries {
      status
      inquiryId
      person {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetPersonas__
 *
 * To run a query within a React component, call `useGetPersonas` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonas` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonas({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetPersonas(baseOptions: Apollo.QueryHookOptions<GetPersonas, GetPersonasVariables> & ({ variables: GetPersonasVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonas, GetPersonasVariables>(GetPersonasDocument, options);
      }
export function useGetPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonas, GetPersonasVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonas, GetPersonasVariables>(GetPersonasDocument, options);
        }
export function useGetPersonasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonas, GetPersonasVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonas, GetPersonasVariables>(GetPersonasDocument, options);
        }
export type GetPersonasHookResult = ReturnType<typeof useGetPersonas>;
export type GetPersonasLazyQueryHookResult = ReturnType<typeof useGetPersonasLazyQuery>;
export type GetPersonasSuspenseQueryHookResult = ReturnType<typeof useGetPersonasSuspenseQuery>;
export type GetPersonasQueryResult = Apollo.QueryResult<GetPersonas, GetPersonasVariables>;